/** Стиль-пак «bright-pop» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'bright-pop',
  shape: {
    radiusCard: 12, radiusOption: 12, radiusButton: 'pill', radiusImage: 12,
    borderWidth: 2, borderTone: 'brand-soft', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 56, optionPadY: 14, optionPadX: 16, gap: 16, contentMaxWidth: 460, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 28, h1Weight: 700, h1Tracking: 0,
    qSize: 28, qWeight: 700, qTracking: 0, optionSize: 16, optionWeight: 400,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'bar', progressLabel: 'none', counter: false, backButton: 'icon-circle', logo: 'center' },
  cta: { placement: 'inline', fullWidth: true, height: 52, disabledStyle: 'muted-brand' },
  states: { selected: 'brand-border-tint', hoverTint: true, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'label-overlay-bottom', overlayTone: 'brand', frame: 'rounded',
    promptHint: 'bright lifestyle photo, saturated accent color, clean background',
  },
  // Coursiv/Dr. Kegel: вопрос сверху, плашки со стрелкой под ним. Яркое
  // lifestyle-фото без ровной вуали съедает контраст акцентного цвета.
  layout: { alignY: 'top', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // Coursiv/Dr. Kegel: динамика — стадии стекаются, процент растёт, бейджи
  // доверия рядом; пак и так построен на движении и акцентах.
  loader: {
    style: 'stacked-stages', showPercent: true, socialProof: 'laurels',
    answersSummary: false, engagementModals: true,
  },
  // Coursiv/Dr. Kegel: яркий пак торгует громко — крупные цифры таймера с
  // подписями, перфорированный тикет, цена за день, чип на рамке, гаснущие
  // соседи, sticky-хедер и повторный блок покупки внизу.
  paywall: {
    timer: 'digits-labeled', promoTicket: 'perforated', priceMode: 'per-day',
    planHighlight: 'chip-on-border', dimUnselectedPlans: true,
    stickyHeader: true, repeatPurchaseBlock: true,
  },
  // Насыщенный бренд сам звучит «премиально», отдельное золото в поп-палитре
  // читалось бы грязно; зелёный остаётся за деньгами и гарантией.
  accents: { money: 'success', premium: 'brand' },
};
